var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedAlertInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20448_35448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.33366C11.6806 1.33366 14.6654 4.31843 14.6654 8.00033C14.6654 11.6822 11.6806 14.667 7.9987 14.667C4.3168 14.667 1.33203 11.6822 1.33203 8.00033C1.33203 4.31843 4.3168 1.33366 7.9987 1.33366Z",
    stroke: "#EE4F4F",
    strokeWidth: 1.30909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.667V8.00033",
    stroke: "#EE4F4F",
    strokeWidth: 1.30909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33301H8.00636",
    stroke: "#EE4F4F",
    strokeWidth: 1.30909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20448_35448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlertInfo);
export default __webpack_public_path__ + "static/media/red_alert_info.40e4739867915a171b72638015266f29.svg";
export { ForwardRef as ReactComponent };